import { useState, useEffect } from 'react';

import { listenToNotifications } from '@/slw/shared/lib/firebase/utils';

export function useNotifications(userId?: string) {
  const [notificationData, setNotificationData] = useState({
    count: 0,
    loading: true,
    error: null,
  });

  useEffect(() => {
    if (!userId) {
      setNotificationData((prev) => ({ ...prev, loading: false }));

      return;
    }

    const unsubscribe = listenToNotifications(userId, (data) => {
      if (data.success) {
        setNotificationData({
          count: data.notificationCount || 0,
          loading: false,
          error: null,
        });
      } else {
        setNotificationData((prev) => ({
          ...prev,
          loading: false,
        }));
      }
    });

    return unsubscribe;
  }, [userId]);

  return notificationData;
}
